<ngx-loading-bar [includeSpinner]="false" [height]="'2px'" [color]="'#ffffff'"></ngx-loading-bar>
<app-head-tours></app-head-tours>
<router-outlet></router-outlet>
<app-footer></app-footer>

